import {message} from '@sail/intl';

export const closeButtonLabel = message({
  id: '@sail/ui.popover.closeButtonLabel',
  description: 'The label for the close button in a popover',
  defaultMessage: 'Close',
});
